module.exports = __webpack_public_path__ + "static/media/icn_concert_60x60.a400e375.svg";